<script lang="ts">
  import { AlertDialog as AlertDialogPrimitive } from "bits-ui";
  import { cn } from "$utils/ui";

  type $$Props = AlertDialogPrimitive.DescriptionProps;

  let className: $$Props["class"] = undefined;
  export { className as class };
</script>

<AlertDialogPrimitive.Description class={cn("text-base text-muted-foreground", className)} {...$$restProps}>
  <slot />
</AlertDialogPrimitive.Description>
